<script>
    import { createEventDispatcher } from "svelte";
    import { Plus,Minus } from '../../index'
    const dispatch = createEventDispatcher();
    let cls = "sui-inputnumber";
    export let value = 0;
    export let digits = 0;
    export let disabled = false;
    export let inputReadOnly = false;
    export let max = Number.MAX_SAFE_INTEGER;
    export let min = Number.MIN_SAFE_INTEGER;
    export let step = 1;

    const handleMunus = () => {
        if(value === min) return
        value = value - step
        dispatch("change", value.toFixed(digits));
    };
    const handlePlus = () => {
        if(value === max) return
        value = value + step
        dispatch("change", value.toFixed(digits));
    };
</script>

<div class={cls} class:disabled={disabled}>
    <button type="button" on:click={handleMunus} class:disabled={value === min} class={`${cls}-minus`}
        >
        <Minus/>
        </button
    >
    <input
        type="text"
        role="spinbutton"
        {min}
        {max}
        {step}
        value={value.toFixed(digits)}
        {disabled}
        readonly={inputReadOnly}
        on:focus
        on:blur
    />
    <button type="button" on:click={handlePlus} class:disabled={value === max} class={`${cls}-plus`}><Plus/></button>
</div>

<style lang="less">
    @import "./inputNumber.less";
</style>
